// hide/show if item alreadt viewd
// select [data-toggle="localstorage"] element
// get [data-localstorage-key] value
// check if it's exist in localstorage
// hide/show element accordingly

document.querySelectorAll('[data-toggle="localstorage"]').forEach((item: HTMLElement) => {
    const key = item.dataset['localstorageKey'];
    let hide = false;
    if (!!key && typeof (Storage) !== "undefined") {
        hide = !!localStorage.getItem(key);
    }

    // toggle .show class
    item.classList.toggle('show', !hide);
});



// store to localstorage
// select [data-toggle="localstorage"] element
// get [data-localstorage-store] value
// store to localstorage
document.querySelectorAll('[data-toggle="localstorage"]').forEach((item: HTMLElement) => {
    const key = item.dataset['localstorageStore'];
    if (!!key && typeof (Storage) !== "undefined") {
        localStorage.setItem(key, 'true');
    }
});

export default undefined;